import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

import { objectsRHandler } from '@/utils/objectsRHandler';
import { getApiData, API_TYPES } from '@/utils/modelsApi';
import { ROLES } from '@/constants/roles';
import { PER_PAGE } from '@/constants/pagination';

import EventAnnouncement from '../list/event-announcement';
import EventAnnouncementSorted from '../list/event-announcement-sorted';
import { corvertQuery } from '@/modules/UserEventLanding/functions';

const API_PATH_SORTED = 'announcements';

/**
 * @param {Object<{}>} { data }
 * @data Object<{
 *   organizer_id?: Number,
 *   event_association_id?: Number,
 *   municipality_id?: Number,
 *   region_id?: Number
 * }>
 * @returns {Array<EventAnnouncementSorted[]>}
 */
const sorted = ({ data, params }) => rHandler(
  apiService.post(API_PATH_SORTED + corvertQuery(params), data),
  (response) => ({
    response,
    items: response.data.data.map((i) => new EventAnnouncementSorted(i, API_PATH_SORTED)),
  }),
  (error) => ({ error }),
);

const PRIVATE_ROLES = [ROLES.organization, ROLES.department, ROLES.admin, ROLES.operator];
const API_DATA = {
  [API_TYPES.private]: {
    path: 'plan-announcements',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, EventAnnouncement),
        create({ data, params }) {
          return rHandler(
            apiService.post(path + corvertQuery(params), data),
            (response) => ({
              response,
              item: new EventAnnouncement(response.data.data, path),
            }),
            (error) => ({ error }),
          );
        },
        sorted,
      };
    },
  },
  [API_TYPES.public]: {
    path: 'public/plan-announcements',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, EventAnnouncement),
        sorted,
      };
    },
  },
};

export const EventAnnouncementsManager = {
  get objects() {
    return {
      ...getApiData(API_DATA, PRIVATE_ROLES).objects,
      getStatistics({ data, params, onlyPlans = false }) {
        const statisticsParams = {
          ...params,
          page: 1,
          'per-page': PER_PAGE.infinity,
        };
        if (onlyPlans) {
          return this.index({
            params: {
              ...statisticsParams,
              fields: 'id,start_at,end_at,event',
              expand: 'event',
            },
          });
        }
        return this.sorted({ data, params: statisticsParams });
      },
    };
  },
};
